import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import "react-toastify/dist/ReactToastify.css";
import Card from "components/card";
import { Button, ChakraProvider, Spinner } from "@chakra-ui/react";
import CreatableSelect from "react-select/creatable";
import {
  createUserApi,
  getSuggestion,
  getUserByIdApi,
  handleCreateUserApi,
} from "services/customAPI";
import theme from "theme/theme";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import Navbar from "components/navbar";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
    borderRadius: "11px",
    borderWidth: "2px",
    width: "auto",

    padding: "5px 0px",
    marginTop: "4px",
    borderColor: state.isFocused ? "teal.500" : "gray.600",
    backgroundColor: "transparent",
    "&:hover": {
      borderColor: state.isFocused ? "teal.500" : "gray.600",
    },
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected ? "teal.500" : "white",
    color: state.isSelected ? "black" : "black",
  }),
};

const Logger = (props: any): JSX.Element => {
  const firstRender = useRef(true);
  const formik = useFormikContext<any>();
  const params = useParams();

  React.useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      if (formik.values?.documents?.length > 0) {
        console.log("docu true");
      } else {
        console.log("docu false");
        if (params.id) {
        }
      }

      console.log("documents values in logger :>> ", formik.values?.documents);
    }
  }, [formik.values?.documents]);

  return null;
};

type formvalues = {
  name: string;
  userName: string;
  password: string;
  confirmPassword: string;
  role: string;
  project: string;
};

const AdminForm: React.FC = () => {
  const project = useSelector((store: any) => store.auth.project);
  const user = useSelector((store: any) => store.auth.user);
  const [initialFormValues, setInitialFormValues] = useState<formvalues>({
    name: "",
    userName: "",
    password: "",
    confirmPassword: "",
    role: "admin",
    project: user == "superAdmin" ? project : "",
  });
  const [suggestionProject, setSuggestionProject] = useState([]);
  const loadData = async () => {
    const data: any = await getSuggestion();
    const { projects } = data;

    if (projects?.length > 0) {
      const opt = projects.map((e: any) => {
        return { value: e, label: e };
      });
      setSuggestionProject(opt);
    }
  };

  useEffect(() => {
    //?data
    loadData();
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const params = useParams<{ id?: string }>();

  const [isAdmin, setIsAdmin] = useState(true);
  console.log("dfsdf", user);
  const adminSchema = Yup.object().shape({
    name: Yup.string()
      .min(2, "Name must be atleast two characters.")
      .required("Name is required"),
    userName: Yup.string()
      .required("Please provide your contact number")
      .test("valid-mobile", "Invalid mobile number", (value) =>
        /^[6-9]{1}\d{9}$/.test(String(value))
      ),
    password: params.id
      ? Yup.string()
      : Yup.string()
          .required("Your password is required")
          .matches(
            /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/,
            "Password must contain at least 8 characters, including one uppercase letter, one lowercase letter, one number, and one special character."
          ),
    confirmPassword: params.id
      ? Yup.string()
      : Yup.string()
          .oneOf([Yup.ref("password"), null], "Passwords must match")
          .required("Confirm Password is required"),
    project:
      isAdmin &&
      Yup.string()
        .required("Project is required!!")
        .min(2, "Invalid Project Name"),
  });

  const successToast = (message: string) => {
    toast.success(`${message}`, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      style: { borderRadius: "15px" },
    });
  };

  const errorToast = (message: string) => {
    toast.error(`${message}`, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      style: { borderRadius: "15px" },
    });
  };

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleCreateUser = async (values: any) => {
    setIsLoading(true);
    try {
      if (params.id) {
        const newPassword = values.password || initialFormValues.password;
        const result: any = await handleCreateUserApi(params.id, {
          ...values,
          password: newPassword,
        });
        navigate("/admin/admins");
        successToast("Admin Updated Successfully");
      } else {
        const result: any = await createUserApi(values);
        navigate("/admin/admins");
        successToast("Admin Added Successfully  ");
      }
    } catch (error: any) {
      errorToast(error.response.data.message);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getData = async (id: string) => {
    setIsLoading(true);
    try {
      const res: any = await getUserByIdApi(id);
      const { password, confirmPassword, ...rest } = res;

      setInitialFormValues({
        ...rest,
        // role: "admin",
      });
    } catch (error: any) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (params.id) {
      getData(params.id);
    }
  }, [params]);

  return (
    <>
      <Navbar flag={false} brandText="driverform" />

      {isLoading ? (
        <div className="flex min-h-screen items-center justify-center">
          <ChakraProvider>
            <Spinner
              thickness="4px"
              speed="0.999s"
              emptyColor="gray.200"
              color="green.500"
              size="xl"
            />
          </ChakraProvider>
        </div>
      ) : (
        <Card extra={"w-full pb-6 p-4 mt-4 pt-10"}>
          <header className="relative flex items-center justify-between ps-10">
            {params.id ? (
              <div className="text-xl font-bold text-navy-700 dark:text-white">
                Edit Admin
              </div>
            ) : (
              <div className="text-xl font-bold text-navy-700 dark:text-white">
                Add Admin
              </div>
            )}
          </header>
          <div className="max-w-7xl p-10 pb-5 pe-20 ps-10	">
            <Formik
              enableReinitialize={true}
              initialValues={initialFormValues}
              onSubmit={(values: any) => {
                handleCreateUser(values);
              }}
              validationSchema={adminSchema}
            >
              {({
                handleChange,
                setFieldValue,
                handleBlur,
                handleSubmit,
                values,
                errors,
                touched,
              }: any) => (
                <form onSubmit={handleSubmit}>
                  <div className="flex justify-between">
                    <div className="mb-3 me-6 w-full">
                      <label
                        htmlFor="name"
                        className="input-custom-label font-bold dark:text-white"
                      >
                        Name
                      </label>
                      <input
                        className="mt-2 h-12 w-full rounded-xl border border-gray-400 bg-white/0 p-3 text-sm font-bold outline-none dark:text-white"
                        required
                        name="name"
                        type="text"
                        id="name"
                        width="90%"
                        placeholder="Name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.name}
                        aria-describedby="exampleFormControlInputHelpInline"
                      />
                      {errors.name && touched.name ? (
                        <div className="error-input ms-2 mt-2 font-bold text-red-600">
                          {errors.name}
                        </div>
                      ) : null}
                    </div>
                    <div className="mb-3 ms-6 w-full">
                      <label
                        htmlFor="userName"
                        className="input-custom-label font-bold dark:text-white"
                      >
                        Username
                      </label>
                      <input
                        className="mt-2 h-12 w-full rounded-xl border border-gray-400 bg-white/0 p-3 text-sm font-bold outline-none dark:text-white"
                        required
                        name="userName"
                        type="text"
                        id="userName"
                        width="90%"
                        placeholder="Mobile Number"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.userName}
                        aria-describedby="exampleFormControlInputHelpInline"
                      />
                      {errors.userName && touched.userName ? (
                        <div className="error-input ms-2 mt-2 font-bold text-red-600">
                          {errors.userName}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="flex justify-between">
                    <div className="mb-3 me-6 w-full">
                      <label
                        htmlFor="password"
                        className="input-custom-label font-bold dark:text-white"
                      >
                        Password
                      </label>
                      <div className="relative">
                        <input
                          className="mt-2 h-12 w-full rounded-xl border border-gray-400 bg-white/0 p-3 text-sm font-bold outline-none dark:text-white"
                          required={!params.id}
                          name="password"
                          type={showPassword ? "text" : "password"}
                          id="password"
                          width="90%"
                          placeholder="Password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.password}
                          aria-describedby="exampleFormControlInputHelpInline"
                        />
                        <span className="absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3">
                          {showPassword ? (
                            <MdVisibilityOff
                              className="text-gray-500"
                              onClick={togglePassword}
                            />
                          ) : (
                            <MdVisibility
                              className="text-gray-500"
                              onClick={togglePassword}
                            />
                          )}{" "}
                        </span>
                      </div>
                      {errors.password && touched.password ? (
                        <div className="error-input ms-2 mt-2 font-bold text-red-600">
                          {errors.password}
                        </div>
                      ) : null}
                    </div>
                    <div className="mb-3 ms-6 w-full">
                      <label
                        htmlFor="confirmPassword"
                        className="input-custom-label font-bold dark:text-white"
                      >
                        Confirm Password
                      </label>
                      <div className="relative">
                        <input
                          className="mt-2 h-12 w-full rounded-xl border border-gray-400 bg-white/0 p-3 text-sm font-bold outline-none dark:text-white"
                          required={!params.id}
                          name="confirmPassword"
                          type={showConfirmPassword ? "text" : "password"}
                          id="confirmPassword"
                          width="90%"
                          placeholder="Confirm Password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.confirmPassword}
                          aria-describedby="exampleFormControlInputHelpInline"
                        />
                        <span className="absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3">
                          {showConfirmPassword ? (
                            <MdVisibilityOff
                              className="text-gray-500"
                              onClick={toggleConfirmPassword}
                            />
                          ) : (
                            <MdVisibility
                              className="text-gray-500"
                              onClick={toggleConfirmPassword}
                            />
                          )}{" "}
                        </span>
                      </div>
                      {errors.confirmPassword && touched.confirmPassword ? (
                        <div className="error-input ms-2 mt-2 font-bold text-red-600">
                          {errors.confirmPassword}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {user === "superAdmin" && (
                    //? main div
                    <div className="flex">
                      {/* //?div1 */}
                      <div
                        className="mb-3 me-11 flex w-full flex-col"
                        style={{ maxWidth: "558px" }}
                      >
                        <label
                          htmlFor="landlineNumber"
                          className="input-custom-label font-bold dark:text-white"
                        >
                          Admin / SuperAdmin
                        </label>
                        <select
                          className="dark:text-black mt-2 h-12 w-full rounded-xl border border-gray-400 bg-white/0 p-3 text-sm font-bold outline-none"
                          required
                          name="role"
                          id="role"
                          onChange={(e: any) => {
                            handleChange(e);
                            e.target.value === "admin"
                              ? setIsAdmin(true)
                              : setIsAdmin(false);
                          }}
                          onBlur={handleBlur}
                          value={values?.role}
                          // style={{"float:below"}}
                        >
                          <option
                            className="dark:text-black font-bold dark:!bg-navy-700 "
                            value="admin"
                          >
                            Admin
                          </option>
                          <option
                            className="dark:text-black rounded-b-lg font-bold dark:!bg-navy-700"
                            value="superAdmin"
                          >
                            SuperAdmin
                          </option>
                        </select>

                        {errors.role && touched.role ? (
                          <div className="error-input ms-2 mt-2 font-bold text-red-600">
                            {errors.role}
                          </div>
                        ) : null}
                      </div>
                      {/* //?div2 */}
                      {isAdmin && values.role != "superAdmin" ? (
                        <div className=" w-full">
                          <label
                            htmlFor="project"
                            className="input-custom-label font-bold dark:text-white"
                          >
                            Project
                          </label>
                          <div className="relative">
                            <CreatableSelect
                              options={suggestionProject}
                              name="project"
                              id="project"
                              defaultValue={
                                values?.project && {
                                  value: values?.project,
                                  label: values?.project,
                                }
                              }
                              // inputValue={values.department}
                              // onInputChange={(e) => handleChange(e)}
                              onChange={(e: any) => {
                                setFieldValue("project", e?.value);
                              }}
                              // className="custom-select-control mt-2 h-12 w-full rounded-xl border border-gray-400 bg-white/0 p-3 text-sm font-bold outline-none dark:text-white"
                              classNamePrefix="custom-select"
                              styles={customStyles}
                            />
                            {errors.project ? (
                              <div className="error-input ms-2 mt-2 font-bold text-red-600">
                                {errors.project}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      ) : (
                        <div className=" w-full"></div>
                      )}
                    </div>
                  )}

                  <div className="button-save-cancel mt-3 flex justify-end">
                    <ChakraProvider theme={theme}>
                      <Button
                        color="gray"
                        colorScheme="gray"
                        variant="outline"
                        borderRadius="md"
                        className=" cancel-button my-2 ms-1 sm:my-0"
                        onClick={() => navigate("/admin/admins")}
                      >
                        Cancel
                      </Button>
                    </ChakraProvider>
                    <Button
                      // color="dark"
                      type="submit"
                      className="save-button my-2 ms-1 rounded-md bg-brand-500 px-2 py-1 text-lg text-white dark:bg-brand-400 sm:my-0"
                      onClick={() => handleSubmit}
                    >
                      Save
                    </Button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </Card>
      )}
    </>
  );
};
export default AdminForm;
